'use client';

import { useTemplateTracker } from '@lichtblick/cms/hooks/useTemplateTracker';
import type { FC } from 'react';

export const TemplateTracker: FC<{
  contentGroup?: string;
  contentGroup2?: string;
  contentGroup3?: string;
  metaTitle?: string;
  trackingPageArea?: string;
}> = ({ contentGroup, contentGroup2, contentGroup3, metaTitle, trackingPageArea }) => {
  useTemplateTracker({
    contentGroup,
    contentGroup2,
    contentGroup3,
    pageArea: trackingPageArea ?? '',
    pageType: 'faq-overview',
    pageTitle: metaTitle ?? '',
  });

  return null;
};
